import { create } from 'zustand';

export type NotificationType = 'success' | 'error' | 'info' | 'warning';

export interface Notification {
  id: string;
  message: string;
  type: NotificationType;
  duration?: number; // в миллисекундах, undefined = не закрывается автоматически
}

interface NotificationState {
  notifications: Notification[];
  maxNotifications: number;
  addNotification: (message: string, type?: NotificationType, duration?: number) => void;
  removeNotification: (id: string) => void;
  clearNotifications: () => void;
}

const useNotificationStore = create<NotificationState>((set) => ({
  notifications: [],
  maxNotifications: 5, // Максимум 5 уведомлений одновременно
  
  addNotification: (message: string, type: NotificationType = 'info', duration: number = 3000) => {
    const id = `notification-${Date.now()}-${Math.random()}`;
    const notification: Notification = { id, message, type, duration };
    
    set((state) => {
      const newNotifications = [...state.notifications, notification];
      
      // Если превышен лимит, удаляем самое старое уведомление
      if (newNotifications.length > state.maxNotifications) {
        return {
          notifications: newNotifications.slice(1), // Убираем первое (самое старое)
        };
      }
      
      return {
        notifications: newNotifications,
      };
    });
    
    // Автоматическое удаление через указанное время
    if (duration) {
      setTimeout(() => {
        set((state) => ({
          notifications: state.notifications.filter((n) => n.id !== id),
        }));
      }, duration);
    }
  },
  
  removeNotification: (id: string) => {
    set((state) => ({
      notifications: state.notifications.filter((n) => n.id !== id),
    }));
  },
  
  clearNotifications: () => {
    set({ notifications: [] });
  },
}));

export { useNotificationStore };

